<template>

    <div class="bg-secondary py-5">

        <inertia-head title="Login">
        </inertia-head>

        <div class="container">
            <div class="row justify-content-center">
                <div class="col" style="max-width: 360px;">
                    <div class="card rounded-3 shadow border-0">
                        <div class="card-header border-0">{{ __('Login') }}</div>

                        <div class="card-body">

                            <form @submit.prevent="form.post(route('login'))" v-if="loginFormOpen">
                                <text-input type="email" dusk="email" :floating="true" label="email" v-model="form.email" :error="form.errors.email" autocomplete="email" autofocus />
                                <text-input type="password" dusk="password" :floating="true" label="password" v-model="form.password" :error="form.errors.password" autocomplete="current-password" />
                                <checkbox-input label="remember" dusk="remember" v-model="form.remember" :error="form.errors.remember" />
                                <submit-button label="Login" dusk="submit" child-class="w-100" />
                            </form>
                            <div class="d-grid gap-3" v-else>
                                <a :href="oauthLoginUrl" class="btn btn-lg btn-outline-dark" v-if="oauthLoginUrl">
                                    <b>{{ __('Login für Labor-Inhaber') }}</b><br />
                                    {{ __('mit :org-Account', {org: $page.props.app.org}) }}
                                </a>
                                <button class="btn btn-lg btn-outline-dark"
                                        @click="openLoginForm"
                                        dusk="login-as-employee"
                                        >
                                    {{ __('Login für Labor-Mitarbeiter') }}
                                </button>
                                <button class="btn btn-lg btn-outline-dark"
                                        @click="openLoginForm"
                                        dusk="login-as-supplier"
                                        >
                                    {{ __('Login für Händler') }}
                                </button>

                                <div v-if="route().has('password.request')">
                                    <inertia-link :href="route('password.request')">
                                        {{ __('Forgot Your Password?') }}
                                    </inertia-link>
                                </div>

                            </div>

                            <div class="d-grid gap-3" v-if="$page.props.canRegister">
                                <div class="">
                                    <hr />
                                    {{ __('Neu hier?') }}
                                </div>
                                <inertia-link :href="route('register')" class="btn btn-lg btn-primary">
                                    {{ __('Register') }}
                                </inertia-link>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

    import SlimLayout from '@/shared/Layouts/SlimLayout';

    import TextInput from '@/shared/Inputs/TextInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        layout: SlimLayout,
        props: [
            'oauthLoginUrl',
        ],
        data() {
            return {
                loginFormOpen: false,
                form: this.$inertia.form({
                    email: null,
                    password: null,
                    remember: null,
                }),
            }
        },
        components: {
            TextInput,
            CheckboxInput,
            SubmitButton,
        },
        computed: {
        },
        methods: {
            openLoginForm()
            {
                this.loginFormOpen = true;
            }
        },
    }
</script>
